import { render, staticRenderFns } from "./TheComputerAssetAddForm.vue?vue&type=template&id=480ee6fc&"
import script from "./TheComputerAssetAddForm.vue?vue&type=script&lang=js&"
export * from "./TheComputerAssetAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports